import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { observer } from 'mobx-react';
import { SketchPicker } from 'react-color';
import {
    FlexDiv,
    SpaceBetweenDiv,
    TextLead,
    TextDefault,
} from '@awarego-ui/components';
import styled from 'styled-components';

const ColorSquare = styled(FlexDiv)`
    width: 32px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    cursor: pointer;
`;

const PopoverContainer = styled.div`
    position: fixed;
    top: ${(props) => props.top}px;
    left: ${(props) => props.left}px;
    z-index: 9999;
`;

const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    background: transparent;
    z-index: 9998;
`;

function EditColor({ primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor }) {
    const [picker, setPicker] = useState(null); // 'primary' | 'secondary' | null
    const [position, setPosition] = useState({ top: 0, left: 0 });

    const handleClick = (event, type) => {
        const rect = event.target.getBoundingClientRect();
        setPosition({ top: rect.bottom + 4, left: rect.left });
        setPicker(type);
    };

    const closePicker = () => setPicker(null);

    const renderPicker = (color, onChange) =>
        createPortal(
            <>
                <Backdrop onClick={closePicker} />
                <PopoverContainer top={position.top} left={position.left}>
                    <SketchPicker
                        color={color}
                        disableAlpha
                        onChange={(c) => onChange(c.hex)}
                    />
                </PopoverContainer>
            </>,
            document.body
        );

    return (
        <FlexDiv column gap={24}>
            {/* Primary color */}
            <SpaceBetweenDiv>
                <FlexDiv column>
                    <TextLead bold>Button and links color</TextLead>
                    <TextDefault>This color is used across the app for various buttons and links.</TextDefault>
                </FlexDiv>
                <ColorSquare
                    backgroundColor={primaryColor}
                    onClick={(e) => handleClick(e, 'primary')}
                />
            </SpaceBetweenDiv>

            {/* Secondary color */}
            <SpaceBetweenDiv>
                <FlexDiv column>
                    <TextLead bold>Navigation highlight color</TextLead>
                    <TextDefault>This color is used for navigation tabs highlights.</TextDefault>
                </FlexDiv>
                <ColorSquare
                    backgroundColor={secondaryColor}
                    onClick={(e) => handleClick(e, 'secondary')}
                />
            </SpaceBetweenDiv>

            {picker === 'primary' &&
                renderPicker(primaryColor, setPrimaryColor)}
            {picker === 'secondary' &&
                renderPicker(secondaryColor, setSecondaryColor)}
        </FlexDiv>
    );
}

export default observer(EditColor);
